import { render, staticRenderFns } from "./molisMerchantList.vue?vue&type=template&id=2c2c997b&scoped=true"
import script from "./molisMerchantList.vue?vue&type=script&lang=ts"
export * from "./molisMerchantList.vue?vue&type=script&lang=ts"
import style0 from "./molisMerchantList.vue?vue&type=style&index=0&id=2c2c997b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c997b",
  null
  
)

export default component.exports